<div class="gallery-type-container" [class.referencePage]="referencePage">

  <div class="row">

    <div class="col-12 col-sm-6 leader-background" [ngStyle]="getLeaderBackground(reference)" *ngIf="index%2===0 || mobileSize">
      <!--<div class="shape"></div>-->
      <app-trapeze-label
        class="left"
        [direction]="'right'"
        [labelValue]="(reference.createdAt | localizedDate).toString().slice(0,4)"></app-trapeze-label>
    </div>
    <div class="col-12 col-sm-6 text-content">

      <div class="text-content-wrapper">
        <div class="text-content-container">
          <div class="section-title">
            <p>{{reference.type}}</p>
          </div>
          <app-section-heading [noMargin]="true" [small]=true [label]="reference.title"></app-section-heading>
<!--          <hr class="divider">-->
          <br>
          <div class="text-content">
            {{reference.summary}}
          </div>
          <br>
          <div *ngIf="!referencePage" class="gallery-button" (click)="openGallery(reference)">Galéria</div>
        </div>
      </div>

    </div>

    <div class="col-12 col-sm-6 leader-background" [ngStyle]="getLeaderBackground(reference)" *ngIf="index%2!==0 && !mobileSize">
      <app-trapeze-label
        class="right"
        [direction]="'left'"
        [labelValue]="(reference.createdAt | localizedDate).toString().slice(0,4)"></app-trapeze-label>
    </div>
  </div>
</div>
